// extracted by mini-css-extract-plugin
module.exports = {"InsuranceClaimsDetailsPageWrapper":"styles_InsuranceClaimsDetailsPageWrapper__3OKOp","ClaimInfoWrapper":"styles_ClaimInfoWrapper__28ooQ"};